import Button from '@ui/components/ui/loading-button';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface TokenExpiredComponentProps {
  sendMails: () => void;
}

const TokenExpiredComponent = ({ sendMails }: TokenExpiredComponentProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <div className="fixed left-1/2 top-1/2 z-10 flex -translate-x-1/2 -translate-y-1/2 flex-col items-center">
      <p className="font-bold text-foreground">{t('titles.linkExpired')}</p>
      <Button variant="contained" className="mt-5 w-full max-w-[40%]" onClick={sendMails}>
        Send mail to all receivers!
      </Button>
    </div>
  );
};

export default TokenExpiredComponent;
